import * as types from './constants';

export default {

    // Set User profile
    [types.GET_USER_PROFILE](state, data) {
        state.userProfile = data;
    },
    // Set User profile edit
    [types.GET_USER_PROFILE_EDIT](state, data) {
        state.userProfileEdit = data;
    },
    [types.GET_HOME_TIME_TABLE](state, data) {
        state.getHomeTimeTable = data;
    },
    [types.GET_USER_INFO](state, data) {
        state.getUserInfo = data;
    },
    [types.GET_BASE_INFO](state, data) {
        state.getBaseInfo = data;
    },
    [types.SET_PARAM_LIST_BOOKS](state, data) {
        state.getParamListelEctricBooks = data;
    },
    [types.MY_EBOOL_LIST](state, data) {
        state.getMyEbookList = data;
    },
    [types.GET_LIST_CLASSES](state, data) {
        state.getListClass = data;
    },
    [types.GET_LIST_BOOK_TYPE](state, data) {
        state.getListBookType = data;
    },
    [types.SET_PACTICE_ACTIVE](state, data) {
        state.practiceActive = data;
    },
    [types.SET_PARAM_ACTIVITY_LIST](state, data) {
        state.paramActivityList = data;
    },
    [types.GET_ACTIVITY_LIST](state, data) {
        state.getActivityList = data;
    },
    [types.GET_ALL_PROVICE](state, data) {
        state.getALLProvice = data;
    },
    [types.GET_LIST_TYPE_SCHOOL](state, data) {
        state.getListTypeSchool = data;
    },
    [types.GET_TYPE_PRACTICE](state, data) {
        state.dataTypePractice = data;
    },
    [types.GET_BOOK_GROUP](state, data) {
        state.dataBookGroup = data;
    },
    [types.GET_SUBJECT](state, data) {
        state.dataSubject = data;
    },
    [types.SET_PARAM_PRACTICE_CHART](state, data) {
        state.pramPracticeChart = data;
    },
    [types.GET_PROCESS_PRACTICE_CHART](state, data) {
        state.getProcessPracticeChart = data;
    },
    [types.SET_PARAM_LEARNING_PROCESS](state, data) {
        state.paramLeaningProcess = data;
    },
    [types.GET_LIST_PROCESS_LEARNING](state, data) {
        state.dataListProcessLearing = data;
    },
    [types.GET_OVER_SUBJECT_CHART](state, data) {
        state.dataOverSubjectChart = data;
    },
    [types.SET_PARAM_LIST_PROCESS_CHAT](state, data) {
        state.paramProcessChat = data;
    },
    [types.GET_LIST_PROCESS_CHAT](state, data) {
        state.dataListProcessChat = data;
    },
    [types.SET_DISPALY_DETAIL](state, data) {
        state.displayDetail = data;
    },
    [types.SET_CHANG_CLASS](state, data) {
        state.changeClass = data;
    },
}

